import React from "react";
//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { StyleEnums } from "models/enums";
import PersonWithPhone from "images/person-phone@2x.png";
import YellowWalkingMan from "images/moonwalk-yellow-man.png";
//#endregion
//#region components
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, Grid, IconButton } from "@mui/material";
//#endregion
import clsx from "clsx";
import { CSSHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const WalkingManDialog: React.FC<DialogProps> = (props) => {
  const [moveDown, setMoveDown] = React.useState(0);
  const [moveLeft, setMoveLeft] = React.useState(0);

  const outerDivRef = React.useRef<HTMLDivElement | null>(null);

  const onClose = () => {
    props.onClose && props.onClose();
    props.closeDialog && props.closeDialog();
  };

  const getImageByDisplayType = (type?: StyleEnums.DisplayType) => {
    switch (type) {
      case StyleEnums.DisplayType.Info:
        return PersonWithPhone;
      case StyleEnums.DisplayType.Warning:
        return YellowWalkingMan;
    }
  };

  const assignRef = (divElement: HTMLDivElement) => {
    outerDivRef.current = divElement;
    if (outerDivRef.current) {
      const height = divElement.offsetHeight;
      const width = divElement.offsetWidth;
      setMoveDown((window.innerHeight - height - 75) / 2.15);
      setMoveLeft((window.innerWidth - width - 130) / 2);
    }
  };

  return (
    <Dialog
      aria-labelledby="dialog-title"
      open={props.isOpen}
      maxWidth="sm"
      hideBackdrop={props.isMinimized && true}
      style={
        props.isMinimized
          ? {
              transform: "translate(" + -moveLeft + "px," + moveDown + "px)",
              transition: "transform 0.5s ease-in-out",
            }
          : {}
      }
      classes={{
        root: cssExports.dialogRoot,
        paper: clsx(
          cssExports.walkingManDialogRoot,
          props.className,
          props.type ? CSSHelper.getClassByDisplayType(props.type) : "",
          props.isMinimized && cssExports.minimizedRoot
        ),
      }}
      onClose={onClose}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={cssExports.walkingManDialogContainer}
        ref={assignRef}
      >
        <IconButton aria-label="close" className={cssExports.closeButtonContainer} onClick={onClose}>
          <CloseIcon />
        </IconButton>

        <Grid container item columnGap={3}>
          <Grid item xs={5} className={cssExports.walkingManContainer}>
            {props.customContent ?? <img src={getImageByDisplayType(props.type)} className={cssExports.walkingMan} />}
          </Grid>
          <Grid container item xs direction="column" justifyContent="center">
            {props.splashText && (
              <Grid item className={cssExports.walkingManBubble}>
                {props.splashText}
              </Grid>
            )}
            <Grid item className={cssExports.walkingManTitle}>
              {props.title}
            </Grid>
            <Grid item className={cssExports.walkingManContent}>
              {props.children as React.ReactNode}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default WalkingManDialog;
